module.exports = __webpack_public_path__ + "img/dashchart.d36db90f.svg";